export enum TaxpayerSpecialVerificationLinks {
  StartVerification = '/settings/taxpayer_verification_education',
  CorrectYourReport = '/settings/taxpayer_verification_correction',
  NavigateToSpecialVerificationForm = '/settings/taxpayer_verification_form',
}
